import request from '../../../helpers/request';

const deleteFacility = async (id) => {
  await request.delete(
    `/RentPlace/rental_house/${id}`,
    {},
    'При удалении объекта произошла ошибка'
  );
};

export default deleteFacility;
